import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
//Limitless imports
import PictureCard from "../picture-card/PictureCard";
import useCustomTheme from "expert-web-app/src/utils/hooks/useCustomTheme";
import { ThemeProvider } from "@emotion/react";
const AnnouncementCard = ({
  classes,
  theme,
  title,
  imageSource,
  backgroundColor,
  date,
  state
}) => {
  const customTheme = useCustomTheme();
  const color = backgroundColor ? backgroundColor : customTheme.palette.primary.main;
  const image = imageSource ? imageSource : theme.assets.logoImg;
  const imageStyles = imageSource ? "" : classes.limitlessLogo;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(PictureCard, {
    leftAlign: true,
    title: title,
    imageSource: image,
    backgroundColor: color,
    date: date,
    size: "medium",
    imageStyles: imageStyles,
    hasViewed: state === "unread" ? false : true
  }));
};
const styles = {
  limitlessLogo: {
    height: 70
  }
};
export default withStyles(styles, {
  withTheme: true
})(AnnouncementCard);
AnnouncementCard.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  title: PropTypes.string,
  imageSource: PropTypes.string,
  backgroundColor: PropTypes.string,
  date: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired
};
AnnouncementCard.defaultProps = {
  title: "",
  state: "unread"
};